import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactTour from 'reactour';
import { Button, colors } from '@mui/material';
import eventManager from 'util/EventEmitter';
import { scrollTo } from 'util/helpers';
import type { ITutorial, TourStep } from 'util/tutorial';

interface Props {
  open: boolean;
  isFirstVisit: boolean;
  onClose: () => void;
  steps: ITutorial;
}

function TourStyled(props: Props) {
  const { t } = useTranslation();
  const { open, onClose, isFirstVisit, steps: incommingTuto } = props;
  const [steps, setSteps] = useState<TourStep[]>([]);
  const [tuto, setTuto] = useState<ITutorial>(incommingTuto);

  useEffect(() => {
    if (incommingTuto) {
      setTuto(incommingTuto);
    }
  }, [incommingTuto]);

  useEffect(() => {
    setSteps(tuto.generateSteps(t));
  }, [t]);

  useEffect(() => {
    eventManager.emmit('open_tutorial', open);
  }, [open]);

  const afterOpen = () => {
    scrollTo('maker_2_main', 'end');
    setSteps(tuto.generateSteps(t));
    tuto.runTasks(0);
  };

  const onChangeStep = (n: number) => {
    tuto.runTasks(n);
    eventManager.emmit('open_tutorial', open);
  };

  return (
    <div id="tutorial_wrapper">
      <ReactTour
        isOpen={open}
        onRequestClose={onClose}
        steps={steps}
        onAfterOpen={afterOpen}
        getCurrentStep={onChangeStep}
        closeWithMask={false}
        showNavigation={!isFirstVisit}
        showNavigationNumber={false}
        disableInteraction
        disableFocusLock
        accentColor={colors.blue[500]}
        startAt={0}
        maskSpace={1}
        rounded={5}
        lastStepNextButton={
          <Button onClick={onClose} variant="contained" sx={{ minWidth: 'max-content' }}>
            {t('pages.tutorial.okey')}
          </Button>
        }
      />
    </div>
  );
}

export default TourStyled;
